enum InboxMessageType {

    General = "general",
    Server = "server",
    SymbolSubscribed = "symbolSubscribed",
    SymbolUnSubscribed = "symbolUnSubscribed",
    TradePlaced = "tradePlaced",
    TradeUpdated = "tradeUpdated",
    TradeExecuted = "tradeExecuted",
    TradeDeleted = "tradeDeleted",
    TradeFailedDelete = "tradeFailedDelete",
    OrderPlaced = "orderPlaced",
    OrderUpdated = "orderUpdated",
    OrderExecuted = "orderExecuted",
    OrderDeleted = "orderDeleted",
    OrderFailedDelete = "orderFailedDelete",
    PromotionsChanged = "promotionsChanged",
    Withdrawal = "withdrawal"
}

export default InboxMessageType;
